/* CFG 0032 - Collection Description Read More/Less Functionality */
(function () {
    try {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initCollectionDescriptionToggle);
      } else {
        initCollectionDescriptionToggle();
      }
  
      function initCollectionDescriptionToggle() {
        var descriptionEl = document.querySelector('[data-description-content]');
        var toggleBtn = document.querySelector('[data-read-more-btn]');
  
        if (!descriptionEl || !toggleBtn) return;
  
        // Determine if content overflows the collapsed container
        var isOverflowing = descriptionEl.scrollHeight > descriptionEl.clientHeight + 1;
        if (!isOverflowing) {
          toggleBtn.style.display = 'none';
          return;
        }
  
        // Accessible state
        toggleBtn.setAttribute('aria-expanded', 'false');
  
        // Cache label spans
        var moreLabel = toggleBtn.querySelector('.cfg-read-more-text');
        var lessLabel = toggleBtn.querySelector('.cfg-read-less-text');
  
        toggleBtn.addEventListener('click', function () {
          var expanded = descriptionEl.classList.toggle('expanded');
          toggleBtn.classList.toggle('expanded', expanded);
          toggleBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  
          if (moreLabel) moreLabel.style.display = expanded ? 'none' : '';
          if (lessLabel) lessLabel.style.display = expanded ? '' : 'none';
        });
      }
    } catch (err) {
      // Fail silently to avoid breaking storefront if something unexpected occurs
      // console.error('CFG 0032 error:', err);
    }
  })();
  /* CFG END 0032 */
  
  